export default __webpack_public_path__ + "static/media/arrow.b0d65c4b.PNG";